/**
 * ThinkWire logo mark — five vertical lines forming a calm wave.
 */
export default function Logo({ size = 22, withText = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="flex-shrink-0"
        style={{ overflow: "visible" }}
      >
        <line x1="2" y1="10.5" x2="2" y2="13.5" stroke="#5147ff" strokeWidth="2" strokeLinecap="round" />
        <line x1="7" y1="6" x2="7" y2="18" stroke="#5147ff" strokeWidth="2" strokeLinecap="round" />
        <line x1="12" y1="2" x2="12" y2="22" stroke="#726aff" strokeWidth="2" strokeLinecap="round" />
        <line x1="17" y1="6" x2="17" y2="18" stroke="#5147ff" strokeWidth="2" strokeLinecap="round" />
        <line x1="22" y1="10.5" x2="22" y2="13.5" stroke="#5147ff" strokeWidth="2" strokeLinecap="round" />
      </svg>
      {withText && (
        <span
          style={{
            fontWeight: 700,
            fontSize: size >= 22 ? 20 : 18,
            letterSpacing: "-0.02em",
            color: "#101014",
          }}
        >
          ThinkWire
          <sup style={{ fontSize: 11, fontWeight: 500, marginLeft: 2, color: "#7c7c76" }}>™</sup>
        </span>
      )}
    </span>
  );
}
